// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DefaultMapContainersSchema.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import {
  createContainerSchema,
  createStaticLabelSchema,
  createConditionalContainerSchema
} from '../FieldContainers/Izenda.FieldContainerSchemaFunctions';
import { SUPPORTED_COUNTRY_COUNTRIES } from 'logic/data/Izenda.MapCollectionConstants';
import { ContainerName, MAP_TYPES } from 'logic/data/Izenda.ReportPartMapConstants';
import localizer from 'share/localization/Izenda.Localizer';
import SecurityManager from 'share/authorization/Izenda.SecurityManager';
import { PERMISSION_KEY } from 'logic/data/Izenda.AuthorizationConstants';
import uiState from 'logic/Izenda.UiState';

const isNotCountry = ({ isMapStyle }) => !isMapStyle(MAP_TYPES.Country);

const isWorldOrSupportedCountry = ({ isMapStyle, properties: { country } }) =>
  isMapStyle(MAP_TYPES.World) || isMapStyle(MAP_TYPES.Google) || SUPPORTED_COUNTRY_COUNTRIES.indexOf(country) > -1;

const isShowAddress = ({ isMapStyle }) =>
  isMapStyle(MAP_TYPES.Google) &&
  (uiState.currentUser.systemAdmin ||
    new SecurityManager().checkPrivileges([PERMISSION_KEY.ReportsReportPartTypesEnableGoogleAddress]));

const CONTAINER_HEIGHT = 70;

export default [
  createStaticLabelSchema('LabelPoint', () => localizer.getText('REPORTDESIGNER_LABEL_POINT_OPTIONS')),
  createConditionalContainerSchema(
    isNotCountry,
    'countryContainer',
    () => localizer.getText('REPORT_PART_MAP_POINT_country'),
    ContainerName.COUNTRY,
    CONTAINER_HEIGHT,
    1,
    true
  ),
  createContainerSchema(
    'stateContainer',
    () => localizer.getText('REPORT_PART_MAP_POINT_state'),
    ContainerName.STATE,
    CONTAINER_HEIGHT,
    1,
    true
  ),
  createConditionalContainerSchema(
    isWorldOrSupportedCountry,
    'countyContainer',
    () => localizer.getText('REPORT_PART_MAP_POINT_county'),
    ContainerName.COUNTY,
    CONTAINER_HEIGHT,
    1,
    true
  ),
  createContainerSchema(
    'cityContainer',
    () => localizer.getText('REPORT_PART_MAP_POINT_city'),
    ContainerName.CITY,
    CONTAINER_HEIGHT,
    1,
    true
  ),
  createContainerSchema(
    'postalCodeContainer',
    () => localizer.getText('REPORT_PART_MAP_POINT_postalCode'),
    ContainerName.POSTAL_CODE,
    CONTAINER_HEIGHT,
    1,
    true
  ),
  createConditionalContainerSchema(
    isShowAddress,
    'addressContainer',
    () => localizer.getText('REPORT_PART_MAP_POINT_address'),
    ContainerName.ADDRESS,
    CONTAINER_HEIGHT,
    1,
    true
  ),
  createContainerSchema(
    'latContainer',
    () => localizer.getText('REPORT_PART_MAP_POINT_latitude'),
    ContainerName.LATITUDE,
    CONTAINER_HEIGHT,
    1,
    true
  ),
  createContainerSchema(
    'lonContainer',
    () => localizer.getText('REPORT_PART_MAP_POINT_longtitude'),
    ContainerName.LONGTITUDE,
    CONTAINER_HEIGHT,
    1,
    true
  ),
  createStaticLabelSchema('LabelValues', () => localizer.getText('REPORTDESIGNER_LABEL_VALUES')),
  createContainerSchema(
    'shadingContainer',
    () => localizer.getText('REPORT_PART_MAP_CONSTANTS_SHADING_METRIC'),
    ContainerName.SHADING_VALUES,
    CONTAINER_HEIGHT,
    1,
    true
  ),
  createContainerSchema(
    'bubbleContainer',
    () => localizer.getText('REPORT_PART_MAP_CONSTANTS_BUBBLE_METRIC'),
    ContainerName.BUBBLE_VALUES,
    undefined,
    undefined,
    true
  )
];



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartMap/Izenda.DefaultMapContainersSchema.js